/**
 * HowItWorks Section - Landing Page
 */

import React from 'react';
import { Card } from '../../../../design-system';

const HowItWorks = ({ language }) => {
  const isArabic = language === 'ar';

  const steps = isArabic
    ? [
        { number: 1, title: 'إنشاء حساب', description: 'سجل حسابك في منصة ShamoTP بسهولة' },
        { number: 2, title: 'تكوين المفاتيح', description: 'احصل على مفاتيح API الخاصة بك' },
        { number: 3, title: 'الدمج', description: 'ادمج API لديك مع تطبيقك' },
        { number: 4, title: 'الإرسال', description: 'ابدأ بإرسال رموز OTP الآن' },
      ]
    : [
        { number: 1, title: 'Create Account', description: 'Sign up for your ShamoTP account easily' },
        { number: 2, title: 'Get API Keys', description: 'Obtain your unique API credentials' },
        { number: 3, title: 'Integrate', description: 'Integrate our API into your application' },
        { number: 4, title: 'Start Sending', description: 'Begin sending OTP codes instantly' },
      ];

  return (
    <section id="how-it-works" className="w-full py-16 sm:py-24 md:py-32 lg:py-48 px-3 sm:px-4 bg-[#0B0E14] relative">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#128C7E]/5 to-transparent pointer-events-none" />
      
      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-4 sm:mb-6">
            {isArabic ? 'كيف يعمل' : 'How It Works'}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#A0AEC0] max-w-2xl mx-auto leading-relaxed">
            {isArabic ? 'أربع خطوات بسيطة للبدء' : 'Get started in 4 simple steps'}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {steps.map((step) => (
            <div key={step.number} className="relative">
              <Card glass hoverable className="relative p-6 sm:p-8 text-center h-full hover:border-[#128C7E]/50 transition-all">
                <div className="mb-4 sm:mb-6 inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#128C7E] to-[#0D6B62] rounded-xl shadow-lg shadow-[#128C7E]/20">
                  <span className="text-white font-bold text-base sm:text-lg">{step.number}</span>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2 sm:mb-3">
                  {step.title}
                </h3>
                <p className="text-[#A0AEC0] text-xs sm:text-sm leading-relaxed">
                  {step.description}
                </p>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
